import { motion as l } from "framer-motion";
import r, { css as e } from "styled-components";
import { Typography as n } from "../../Typography/Typography.es.js";
const y = r.div.withConfig({
  displayName: "AccordionHeaderStart",
  componentId: "sc-188yxvx-0"
})(["display:flex;gap:4px;"]), p = r.div.withConfig({
  displayName: "AccordionHeaderContent",
  componentId: "sc-188yxvx-1"
})(["align-items:flex-start;display:flex;flex-direction:column;gap:4px;"]), f = r.div.withConfig({
  displayName: "AccordionHeaderEnd",
  componentId: "sc-188yxvx-2"
})(["align-items:center;display:flex;gap:4px;"]), t = r.button.withConfig({
  displayName: "AccordionHeader",
  componentId: "sc-188yxvx-3"
})(["background:var(--color-transparent);border:none;display:flex;gap:16px;justify-content:space-between;outline:none;padding:8px 16px;width:100%;", ""], ({
  disabled: o
}) => o && e(["cursor:not-allowed;opacity:0.4;"])), b = r(l.div).withConfig({
  displayName: "AccordionBody",
  componentId: "sc-188yxvx-4"
})([""]), i = {
  sm: {
    fontSize: "1.4rem",
    fontWeight: 400
  },
  md: {
    fontSize: "1.4rem",
    fontWeight: 400
  },
  lg: {
    fontSize: "1.6rem",
    fontWeight: 400
  }
};
var c, a, s;
const u = r.div.withConfig({
  displayName: "Accordion",
  componentId: "sc-188yxvx-5"
})(["background:var(--color-transparent);border-radius:var(--size-border-radius-md);font-size:", ";", "{", ";", ":last-child{font-size:0.8em;}", ":first-child{font-size:1em;line-height:2.4rem;}}", "{", ";", "{font-size:1em;}}", ""], ({
  size: o
}) => i[o].fontSize, p, ({
  size: o
}) => i[o], (c = n.S) == null ? void 0 : c.Typography, (a = n.S) == null ? void 0 : a.Typography, f, ({
  size: o
}) => i[o], (s = n.S) == null ? void 0 : s.Typography, ({
  isOpen: o,
  variant: d
}) => d === "contained" ? e(["border:1px solid var(--color-border-default);", "{background:var(--color-bg-weaker);", "}"], t, o && e(["border-bottom:1px solid var(--color-border-default);"])) : d === "outlined" ? e(["background:var(--color-bg-default);border:1px solid var(--color-border-default);", "{", "}"], t, o && e(["border-bottom:1px solid var(--color-border-default);"])) : d === "text" ? e(["", "{padding:0;}"], t) : e([""]));
export {
  u as Accordion,
  b as AccordionBody,
  t as AccordionHeader,
  p as AccordionHeaderContent,
  f as AccordionHeaderEnd,
  y as AccordionHeaderStart
};
//# sourceMappingURL=style.es.js.map
